
import request from '@/request'
const part_url = 'recruit/web/post/';


/**
 * 查询咨询
 *
 * @param {*} pageNow 当前页
 * @param {*} pageSize 页容
 * @returns
 */
function getList(data) {
  let url = part_url + "getList";
  return request.get(url, data)
}




export default {
    getList,
}



// WEBPACK FOOTER //
// ./src/api/post.js